import { useQuery } from '@tanstack/react-query';
import { httpGetModularWorkflowSteps } from 'services/backofficeIntegration/http/endpoints/modularWorkflow/httpGetModularWorkflowSteps';

export const useModularWorkflowStructure = () => {
  return useQuery({
    queryKey: ['modularWorkflowStructure'],
    queryFn: () => httpGetModularWorkflowSteps.callEndpoint()
  });
};
